import { useState } from 'react';

import { EditOutlined, TeamOutlined, UploadOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';

import type { ISchoolMainData } from '@/api/endpoints/schools';

import { ImportSection } from '../SchoolParticipants/ImportSection/ImportSection';
import { ParticipantsSection } from '../SchoolParticipants/ParticipantsSection/ParticipantsSection';

import { ETabsKeys } from './consts';
import { EditCorporateSchoolComponent } from './EditCorporateSchoolComponent';
import styles from './SchoolEditPage.module.scss';
import { SchoolEditPageTabContext } from './SchoolEditPageTabContext';

type TProps = {
  schoolData: ISchoolMainData;
};

export const EditCorporateSchoolWrapper = ({ schoolData }: TProps) => {
  const [activeTab, setActiveTab] = useState(ETabsKeys.SchoolEdit);

  return (
    <SchoolEditPageTabContext value={{ setActiveTab }}>
      <Tabs
        onChange={(tab) => setActiveTab(tab as ETabsKeys)}
        activeKey={activeTab}
        className={styles.tabs}
        items={[
          {
            key: ETabsKeys.SchoolEdit,
            label: 'Редактирование школы',
            children: <EditCorporateSchoolComponent schoolData={schoolData} />,
            icon: <EditOutlined />,
          },
          {
            key: ETabsKeys.ParticipantsList,
            label: 'Список участников',
            children: <ParticipantsSection />,
            icon: <TeamOutlined />,
          },
          {
            key: ETabsKeys.ParticipantsImport,
            label: 'Импорт участников',
            children: <ImportSection />,
            icon: <UploadOutlined />,
          },
        ]}
      />
    </SchoolEditPageTabContext>
  );
};
